import {
    FILTER_HCPDATA,
    HCP_DATA,
    HCP_SELECTION, EDIT_HCP, NEW_HCP, HCPS_COUNT, HCP_LOCKED_STATUS, CLEAN_HCP,
    DELETE_CLINIC_HCPS
} from "../../constants/Tabs-Action-Types";
import utils from "../../../utils/utils";
import Constants from "../../../utils/constants";


const initialState = {
    initiateHcpData:[],
    hcpData:[],
    selectedHcpData:[],
    hcpTableFilter:{},
    hcpCount: 0
};



const hcpTableDataReducer = (state = initialState, action)=> {

    switch(action.type){

        case DELETE_CLINIC_HCPS:{
            let clinicId = action.clinicId
            let hcpData = state.hcpData
            let initiateHcpData = state.initiateHcpData

            let newhcpData = hcpData.filter(hcp => hcp.ClinicStorageID !== clinicId)
            let newinitiateHcpData = initiateHcpData.filter(hcp => hcp.ClinicStorageID !== clinicId)

            let _pdata = JSON.parse(JSON.stringify(newhcpData));
            let _idata = JSON.parse(JSON.stringify(newinitiateHcpData));

            state = {
                ...state,
                initiateHcpData:_idata,
                hcpData : _pdata,
                hcpCount: newinitiateHcpData.length
            };
            break;
        }


        case HCPS_COUNT:{
            let _idata = JSON.parse(JSON.stringify(action.payload));
            state = {
                ...state,
                hcpCount: _idata
            };
            break;
        }
        case HCP_DATA:
            let collection = []
            action.payload.forEach(hcp =>{
                collection.push({
                    id:hcp.UserID,
                    UserStorageID:hcp.PII.UserStorageID,
                    Clinic_Name:hcp.Clinic.Clinic_Name,
                    Clinic_ID: hcp.Clinic_ID,
                    DefaultVAUnit: hcp.DefaultVAUnit,
                    MedicalLicense: hcp.MedicalLicense,
                    Profession: hcp.Profession,
                    ProfessionLabel: Constants.Profession.find(prof => prof.value === hcp.Profession)?.label,
                    Signature: hcp.Signature,
                    ID_passport: hcp.PII?.ID_passport,
                    ClinicAdmin: hcp.ClinicAdmin,
                    First_name: hcp.PII?.First_name,
                    Last_name: hcp.PII?.Last_name,
                    Email: hcp.PII?.Email,
                    Phone_num1: hcp.PII?.Phone_num1,
                    Enabled: hcp.PII?.User.Enabled,
                    FullName: hcp.PII?.First_name + ' ' + hcp.PII?.Last_name,
                    Patients: hcp.NumOfPatients,
                })
            })

            let _pdata = JSON.parse(JSON.stringify(collection));
            state = {
                ...state,
                initiateHcpData:_pdata,
                hcpData : _pdata,
                hcpCount: collection.length
            };
            break;
        case CLEAN_HCP:{
            state = {
                ...state,
                hcpTableFilter: {},
                selectedHcpData:[]
            };
            break;
        }
        case FILTER_HCPDATA:{
            let type = action.searchType
            let payload = action.payload
            let hcpTableFilter = state.hcpTableFilter
            let filteredHcpsData = state.initiateHcpData
            let visibleFilterData = []
            let visiableData = []

            if (type === 'search' && (payload === '' || payload === null)){
                delete hcpTableFilter.search
            } else {
                utils.set(hcpTableFilter,type,payload)
            }

            for (const [key, value] of Object.entries(hcpTableFilter)) {
                if (key === 'search'){
                    let val = value.toLowerCase()
                    filteredHcpsData = filteredHcpsData.filter(x =>
                        String(x.FullName).toLowerCase().indexOf(val) > -1 ||
                        String(x.MedicalLicense).toLowerCase().indexOf(val) > -1 ||
                        String(x.Clinic_Name).toLowerCase().indexOf(val) > -1 ||
                        String(x.Patients).toLowerCase().indexOf(val) > -1 ||
                        String(x.Email).toLowerCase().indexOf(val) > -1
                    )
                    visibleFilterData = filteredHcpsData
                } else {
                    let hcps = JSON.parse(JSON.stringify(filteredHcpsData))
                    let valArr = JSON.parse(JSON.stringify(value))


                    if (Array.isArray(valArr)){
                        let res = []
                        valArr.forEach(val => {
                            let hcpArr = hcps.filter(hcp => {
                                let hcpVal = hcp[key]
                                return String(hcpVal).toLowerCase() === String(val).toLowerCase()
                            })
                            hcpArr.forEach(hcp => res.push(hcp))
                        })
                        filteredHcpsData = res
                    }
                }
            }
            visiableData = filteredHcpsData

            let _fpdata = JSON.parse(JSON.stringify(visibleFilterData));
            let _vdata = JSON.parse(JSON.stringify(visiableData));
            let _pfdata = JSON.parse(JSON.stringify(hcpTableFilter));
            state = {
                ...state,
                filteredHcpsData: _fpdata,
                hcpData: _vdata,
                hcpTableFilter: _pfdata
            };
            break;
        }
        case HCP_SELECTION:{
            let selection = action.payload
            let initiateHcpData = state.initiateHcpData

            let newSelection = []
            Object.entries(selection).forEach(([key,value]) => {
                if (value){
                    let index = initiateHcpData.findIndex((obj => obj.UserID === key));
                    let name = initiateHcpData[index].FullName
                    newSelection.push({id:key,name})
                }
            })
            state = {
                ...state,
                selectedHcpData: newSelection
            };
            break;
        }
        case NEW_HCP: {
            let hcp = action.payload
            let hcpData = state.hcpData
            let initiateHcpData = state.initiateHcpData
            let newData = [{
                id:hcp.UserID,
                UserID:hcp.UserID,
                Clinic_Name:hcp.Clinic?hcp.Clinic.Clinic_Name:"",
                Clinic_ID: hcp.Clinic?hcp.Clinic.Clinic_ID:"",
                DefaultVAUnit: hcp.Doctor.DefaultVAUnit,
                MedicalLicense: hcp.Doctor.MedicalLicense,
                Profession: hcp.Doctor.Profession,
                Signature: hcp.Doctor.Signature,
                ClinicAdmin: hcp.Doctor.ClinicAdmin,
                ID_passport: hcp.PIIProfile.ID_passport,
                First_name: hcp.PIIProfile.First_name,
                Last_name: hcp.PIIProfile.Last_name,
                Email: hcp.PIIProfile.Email,
                Phone_num1: hcp.PIIProfile.Phone_num1,
                Enabled: hcp.Enabled,
                FullName: hcp.PIIProfile.First_name + ' ' + hcp.PIIProfile.Last_name,
                Patients: hcp.NumOfPatients?hcp.NumOfPatients:0,
            }]

            let newhcpData = hcpData.concat(newData)
            let newinitiateHcpData = initiateHcpData.concat(newData)

            let _pdata = JSON.parse(JSON.stringify(newhcpData));
            let _idata = JSON.parse(JSON.stringify(newinitiateHcpData));
            state = {
                ...state,
                initiateHcpData:_idata,
                hcpData : _pdata,
                hcpCount: newinitiateHcpData.length
            };
            break;
        }
        case EDIT_HCP: {
            let hcp = action.payload

            let hcpData = state.hcpData
            let initiateHcpData = state.initiateHcpData


            let indexData = hcpData.findIndex((obj => obj.UserStorageID === hcp.UserStorageID));
            let indexInit = initiateHcpData.findIndex((obj => obj.UserStorageID === hcp.UserStorageID));


                hcpData[indexData]['Clinic_Name'] = hcp.Clinic.Clinic_Name
                hcpData[indexData]['Clinic_ID']= hcp.Clinic.Clinic_ID
                hcpData[indexData]['DefaultVAUnit']= hcp.DefaultVAUnit
                hcpData[indexData]['MedicalLicense']= hcp.MedicalLicense
                hcpData[indexData]['Profession']= hcp.Profession
                hcpData[indexData]['Signature']= hcp.Signature
                hcpData[indexData]['ClinicAdmin']= hcp.ClinicAdmin
                hcpData[indexData]['ID_passport']= hcp.PII?.ID_passport
                hcpData[indexData]['First_name']= hcp.PII?.First_name
                hcpData[indexData]['Last_name']= hcp.PII?.Last_name
                hcpData[indexData]['Email']= hcp.PII?.Email
                hcpData[indexData]['Phone_num1']= hcp.PII?.Phone_num1
                hcpData[indexData]['FullName']= hcp.PII?.First_name + ' ' + hcp.PII?.Last_name

                initiateHcpData[indexInit]['Clinic_Name'] = hcp.Clinic.Clinic_Name
                initiateHcpData[indexInit]['Clinic_ID']= hcp.Clinic.Clinic_ID
                initiateHcpData[indexInit]['DefaultVAUnit']= hcp.DefaultVAUnit
                initiateHcpData[indexInit]['MedicalLicense']= hcp.MedicalLicense
                initiateHcpData[indexInit]['ClinicAdmin']= hcp.ClinicAdmin
                initiateHcpData[indexInit]['Profession']= hcp.Profession
                initiateHcpData[indexInit]['Signature']= hcp.Signature
                initiateHcpData[indexInit]['ID_passport']= hcp.PII?.ID_passport
                initiateHcpData[indexInit]['First_name']= hcp.PII?.First_name
                initiateHcpData[indexInit]['Last_name']= hcp.PII?.Last_name
                initiateHcpData[indexInit]['Email']= hcp.PII?.Email
                initiateHcpData[indexInit]['Phone_num1']= hcp.PII?.Phone_num1
                initiateHcpData[indexInit]['FullName']= hcp.PII?.First_name + ' ' + hcp.PII?.Last_name

            let _pdata = JSON.parse(JSON.stringify(hcpData));
            let _idata = JSON.parse(JSON.stringify(initiateHcpData));
            state = {
                ...state,
                initiateHcpData:_idata,
                hcpData : _pdata
            };
            break;
        }
        case HCP_LOCKED_STATUS: {
            let hcp = action.payload
            let hcpData = state.hcpData
            let initiateHcpData = state.initiateHcpData

            let indexData = hcpData.findIndex((obj => obj.UserStorageID === hcp.UserStorageID));
            let indexInit = initiateHcpData.findIndex((obj => obj.UserStorageID === hcp.UserStorageID));
            let Enabled = hcp.PII?.User.Enabled

            hcpData[indexData]['Enabled'] = Enabled
            initiateHcpData[indexInit]['Enabled'] = Enabled

            let _pdata = JSON.parse(JSON.stringify(hcpData));
            let _idata = JSON.parse(JSON.stringify(initiateHcpData));

            state = {
                ...state,
                initiateHcpData:_idata,
                hcpData : _pdata,
            };
            break;
        }
        default:
            break;
    }
    return state;
};
export default hcpTableDataReducer;
